/*
 * General custom scripts
 */
import "./front/video";
/*
 * StretchedLink
 */
import { StretchedLink } from "./front/StretchedLink";
new StretchedLink( ".b-image-card" );
import { footerFunction } from "./front/footer";
import { formFunctions } from "./front/forms";
import { AnimateSections } from "./front/AnimateSections";
import { Header } from "../blocks/header/classes/Header";
import resizeManager from "./front/ResizeManager";

footerFunction();
formFunctions();

document.addEventListener( "DOMContentLoaded", () => {

	new AnimateSections( ".b-animation-hero" );
	const header = new Header();

	resizeManager.addListener( header.onResize.bind( header ) );

} );
